import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, FieldArray } from 'redux-form';
import { RadioButtonGroup } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import { CSSTransitionGroup } from 'react-transition-group';
import 'components/tenant_app/components/tenant_profile/TenantProfile.css';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import FlatButton from 'material-ui/FlatButton';

import scrollIntoView from 'scroll-into-view';

import * as validator from 'helpers/Validator';
import { AccentColor } from 'helpers/AccentColorHelper';

import validate from '../validate';
import { RenderError, RenderGhostError } from 'components/shared/RenderError';
import { apiGet } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import styled from 'styled-components';
import { P } from '@yuhu-inc/yuhui';
import { getTranslatedString } from 'helpers/i18n';

const style = {
  button: {
    color: 'white',
    float: 'right',
    height: '40px',
  },
  backButton: {
    float: 'left',
    color: AccentColor(),
    height: '40px',
  },
  add_cotenant_button: {
    color: 'white',
  },
  details: {
    fontFamily: 'Circular',
  },
  emphasis: {
    fontFamily: 'Circular-Black',
  },
};

const StyledErrorP = styled(P)`
  color: var(--yuhu-red);
`;

const renderCotenants = ({ unavailableEmails, fields, meta: { touched, error, submitFailed } }) => {
  const fieldValues = fields.getAll();
  const emails = fieldValues ? fieldValues.map((cotenant) => cotenant.email) : [];

  return (
    <div className="row">
      <CSSTransitionGroup
        transitionName="add_cotenant"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {fields.map((cotenant, index) => (
          <div key={index} className="row" style={{ marginTop: '20px' }}>
            <div className="cotenantHeader" style={{ padding: '0 15px' }}>
              <h4 style={{ lineHeight: '26px' }}>
                {getTranslatedString('tenantPortal.application.cotenants.number', {
                  number: index + 1,
                })}
                <IconButton
                  style={{
                    padding: 0,
                    verticalAlign: 'text-bottom',
                    width: 'none',
                    height: 'none',
                    float: 'right',
                  }}
                  onClick={() => fields.remove(index)}
                >
                  <DeleteIcon size={24} style={{ padding: 0 }} />
                </IconButton>
              </h4>
            </div>

            <div className="row" style={{ marginTop: '20px' }}>
              <div className="col-sm-6">
                <Field
                  name={`${cotenant}.firstName`}
                  type="text"
                  component={TextField}
                  label={getTranslatedString('tenantPortal.application.cotenants.firstName')}
                  style={{ fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                  variant="outlined"
                />
                <Field name={`${cotenant}.firstName`} component={RenderGhostError} />
              </div>
              <div className="col-sm-6">
                <Field
                  name={`${cotenant}.lastName`}
                  type="text"
                  component={TextField}
                  label={getTranslatedString('tenantPortal.application.cotenants.lastName')}
                  style={{ fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                  variant="outlined"
                />
                <Field name={`${cotenant}.lastName`} component={RenderGhostError} />
              </div>
            </div>
            <div className="row" style={{ marginTop: '20px' }}>
              <div className="col-sm-6">
                <Field
                  name={`${cotenant}.email`}
                  type="text"
                  component={TextField}
                  label={getTranslatedString('tenantPortal.application.cotenants.Email')}
                  style={{ fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                  variant="outlined"
                />
                <Field name={`${cotenant}.email`} component={RenderGhostError} />
                {unavailableEmails.includes(emails[index]) && (
                  <StyledErrorP contentKey="tenantPortal.application.emailAlreadyExists" />
                )}
              </div>
              <div className="col-sm-6">
                <Field
                  name={`${cotenant}.phoneNumber`}
                  type="text"
                  label={getTranslatedString('tenantPortal.application.cotenants.phone')}
                  component={ReactPhoneInput}
                  validate={[validator.required, validator.validInternationalPhoneNumber]}
                  style={{ fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                />
                <Field name={`${cotenant}.phoneNumber`} component={RenderGhostError} />
              </div>
            </div>
            <div className="row" style={{ marginTop: '20px', textAlign: 'center' }}>
              <p> {getTranslatedString('tenantPortal.application.cotenants.guarantor')} </p>
              <Field name={`${cotenant}.guarantor`} component={RadioButtonGroup}>
                <RadioButton
                  value="Yes"
                  label={getTranslatedString('tenantPortal.application.cotenants.guarantorYes')}
                  style={{ width: '85px', display: 'inline-flex', fontSize: '18px' }}
                />
                <RadioButton
                  value="No"
                  label={getTranslatedString('tenantPortal.application.cotenants.guarantorNo')}
                  style={{ width: '85px', display: 'inline-flex', fontSize: '18px' }}
                />
              </Field>
              <Field name={`${cotenant}.guarantor`} component={RenderError} />
              <Field name={`${cotenant}.guarantor`} component={RenderGhostError} />
            </div>
          </div>
        ))}
      </CSSTransitionGroup>
      <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
        <FlatButton
          label={getTranslatedString('tenantPortal.application.cotenants.add')}
          type="button"
          backgroundColor={AccentColor()}
          hoverColor="grey"
          style={style.add_cotenant_button}
          onClick={() => {
            fields.push({});
            setTimeout(
              () =>
                document
                  .getElementById('button')
                  .scrollIntoView({ block: 'end', behaviour: 'smooth' }),
              0
            );
          }}
        />

        {error && (
          <p
            style={{
              marginTop: '10px',
              fontSize: '11px',
              color: AccentColor(),
            }}
            id="errorMessage"
          >
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

let WizardFormSecondPage = (props) => {
  const [unavailableEmails, setUnavailableEmails] = useState([]);
  const { handleSubmit, previousPage, hideCotenantsForm, showCotenantsForm, formValues } = props;

  const handleClickNext = async (e) => {
    e.preventDefault();

    if (!formValues.cotenants) {
      return handleSubmit();
    }

    const response = await apiGet(Auth.getApiUrl() + `/leads/lead_emails`, {
      emails: formValues.cotenants.map((cotenant) => cotenant.email).join(','),
    });

    if (response.unavailable_emails.length === 0) {
      handleSubmit();
    } else {
      setUnavailableEmails(response.unavailable_emails);
    }
  };

  return (
    <div id="top" style={{ marginTop: '50px' }}>
      <h3
        style={{
          fontSize: '30px',
          marginBottom: '20px',
          fontFamily: 'Circular-Bold',
        }}
      >
        {getTranslatedString('tenantPortal.application.cotenants.invite')}
      </h3>

      <h4 style={style.details}>
        <b style={style.emphasis}>
          {getTranslatedString('tenantPortal.application.cotenants.tip')}
        </b>{' '}
        {getTranslatedString('tenantPortal.application.cotenants.over18')}
      </h4>
      <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
        <Field name="hasCotenant" component={RadioButtonGroup}>
          <RadioButton
            value="Yes"
            label={getTranslatedString('tenantPortal.application.cotenants.guarantorYes')}
            onClick={showCotenantsForm}
            style={{ width: '85px', display: 'inline-flex', fontSize: '18px' }}
          />
          <RadioButton
            value="No"
            label={getTranslatedString('tenantPortal.application.cotenants.guarantorNo')}
            onClick={hideCotenantsForm}
            style={{ width: '85px', display: 'inline-flex', fontSize: '18px' }}
          />
        </Field>
        <Field name="hasCotenant" component={RenderError} />
      </div>

      <form onSubmit={handleClickNext}>
        <CSSTransitionGroup
          transitionName="fade_out_buttons"
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {props.displayCotenantsForm && (
            <FieldArray
              name="cotenants"
              unavailableEmails={unavailableEmails}
              component={renderCotenants}
              key="test"
            />
          )}
        </CSSTransitionGroup>
        <div id="button" style={{ marginBottom: '75px' }} />
        <div id="application_footerbar">
          <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
            <FlatButton
              label={getTranslatedString('tenantPortal.application.cotenants.button.back')}
              type="button"
              className="previous"
              onClick={previousPage}
              backgroundColor="#fff"
              hoverColor="grey"
              style={style.backButton}
            />
            <FlatButton
              label={getTranslatedString('tenantPortal.application.cotenants.button.Next')}
              type="submit"
              className="next"
              primary={true}
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={style.button}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

WizardFormSecondPage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  dirty: true,
  onSubmitFail: (errors) => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
      align: {
        top: 0.25,
      },
    });
  },
})(WizardFormSecondPage);

WizardFormSecondPage = connect((state) => ({
  displayCotenantsForm: state.tenantApplication.showCotenantsForm,
  formValues: state.form.wizard && state.form.wizard.values,
}))(WizardFormSecondPage);

export default WizardFormSecondPage;
